export default {"src":"/_next/static/media/features-reply-to-emails-anon.f9e57d5c.svg","height":478,"width":521,"blurWidth":0,"blurHeight":0};